import { render, staticRenderFns } from "./configuration-local-accounting-billable-clients-modal-contact-information.vue?vue&type=template&id=10de26c3&"
import script from "./configuration-local-accounting-billable-clients-modal-contact-information.ts?vue&type=script&lang=ts&"
export * from "./configuration-local-accounting-billable-clients-modal-contact-information.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports